<template>
  <div style="width: 100%; margin: 0 auto">
    <div class="body_top">
      <div class="bg_img_div">
        <!-- <img src="@/assets/newYXSCbg.png" /> -->
      </div>
      <!-- 绝对定位 -->
      <div class="body_top_abs">
        <div class="img_he">
          <img class="log_Img" :src="require('@/assets/herder_logo1.png')" alt="" />
        </div>
        <p class="bt1">整合山西优秀视频资源 让作品更高效</p>
        <div class="body_top_abs_gn">
          <!-- <div class="ag_select">
            <span
              v-for="index in bottomList"
              :key="index"
              :class="
                index.checked == true ? 'ag_selectT cur' : 'ag_selectF cur'
              "
              @click="selectClick(index)"
              >{{ index.title }}</span
            >
          </div> -->
          <div class="ag_l">
            <div class="ss_abs_c_srk">
              <input v-model="from1.keyWord" @keyup.enter="getList1" placeholder="输入名称进行搜索" />
              <div class="cur" style="border-radius: 0 0.08rem 0.08rem 0" @click="getList1">
                <img src="../../assets/yxsc_ss.png" />
                搜索
              </div>
              <span class="ss_abs_c_center">或</span>
              <div @click="showReleaseLease" class="ss_abs_c_right cur">
                发布需求
              </div>
            </div>
          </div>
          <div class="log_box">
            <!-- <img src="@/assets/log1.png" />
            <p>x</p>
            <img src="@/assets/log2.png" />
            <p>x</p>
            <img src="@/assets/log3.png" /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="body_main">
      <div class="body_main_a">
        <div class="body_main_a_left">
          <div>
            <img src="../../assets/sb1.png" />
            <div>提交任务需求</div>
          </div>
          <div>
            <img src="../../assets/sb2.png" />
            <div>选择合作人</div>
          </div>
          <div>
            <img src="../../assets/sb3.png" />
            <div>托管金额到平台</div>
          </div>
          <div>
            <img src="../../assets/sb4.png" />
            <div>获得解决方案</div>
          </div>
          <div>
            <img src="../../assets/sb5.png" />
            <div>验收满意付款</div>
          </div>
        </div>
        <div class="body_main_a_right">
          <img src="../../assets/sb_icon1.png" />
          <span>担保交易：资金安全，合作无忧</span>
        </div>
      </div>
      <div class="body_main_b">
        <div class="SL_hotSongwriter">
          <div class="SL_hotSongwriter_title cur">最新需求</div>
          <div @click="goPagelink" class="SL_hotSongwriter_click">
            查看全部 >
          </div>
        </div>
        <moduleNewNeed class="cur" @click="goParticulars(index)" v-for="index in list" :key="index" :item="index">
        </moduleNewNeed>
      </div>
      <div class="body_main_b">
        <div class="SL_hotSongwriter">
          <div class="SL_hotSongwriter_title">热门创作人</div>
          <div class="SL_hotSongwriter_click cur" @click="router.push({ path: '/ShadowComposer' })">
            查看全部 >
          </div>
        </div>
        <el-row :gutter="20">
          <el-col :span="6" v-for="index in userList" :key="index" @click="composer(index)">
            <moduleHotComposer class="cur" :message="index"></moduleHotComposer>
          </el-col>
        </el-row>
        <!-- <moduleNewNeed v-for="(index) in 8" :key="index"></moduleNewNeed> -->
      </div>
    </div>
    <el-dialog title="发布需求" v-model="checked" :before-close="handleClose" align-center :close-on-click-modal="false"
      width="800px">
      <el-form :model="form" label-width="100px" ref="formRef" :rules="rules">
        <el-form-item label="项目名称" prop="projectName" :span="24">
          <el-input v-model="form.projectName" placeholder="请填写项目名称" />
        </el-form-item>
        <el-form-item label="项目描述" prop="projectDescription">
          <el-input type="textarea" v-model="form.projectDescription"
            placeholder="填写详细的描述，可更准确快速匹配合适创作人，可含：需求背景、时长、风格、投放渠道等..." />
        </el-form-item>
        <el-form-item label="联系方式" prop="contactInfo">
          <el-input v-model="form.contactInfo" oninput="value=value.replace(/[^\d.]/g, '')" placeholder="请填写联系方式" />
        </el-form-item>
        <el-form-item label="预算价格" prop="price">
          <el-input v-model="form.price" oninput="value=value.replace(/[^\d.]/g, '')" placeholder="请输入价格">
            <template #append>元</template>
          </el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="交付日期" prop="deliveryTime">
              <el-date-picker v-model="form.deliveryTime" type="date" value-format="x" placeholder="选择交付日期"
                :disabled-date="disabledDate" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作地点" prop="workPlace">
              <el-input v-model="form.workPlace" placeholder="请输入工作地点" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="技能类型" prop="skillType">
          <el-input v-model="form.skillType" placeholder="请输入技能类型" />
        </el-form-item>
        <div style="
            font-size: 0.12rem;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-top: 0.16rem;
            margin-bottom: 0.2rem;
          ">
          <el-checkbox v-model="radio" />
          <div style="color: #333333; margin-left: 0.1rem">已阅读并同意</div>
          <div style="color: #c01a26" @click="openagreement('zywsyxy')">
            《找业务使用协议》
          </div>
        </div>
      </el-form>
      <div style="display: flex; justify-content: center; margin-top: 10px">
        <div class="dataBtn dataBtnQx" @click="handleClose()">取消</div>
        <div class="dataBtn" @click="submitForm()">确认发布</div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import moduleNewNeed from "../../components/moduleNewNeed.vue";
import moduleHotComposer from "../../components/moduleHotComposer.vue";
// import ShadowBusinessParticulars from "../../components/ShadowBusinessParticulars.vue"
import type { FormInstance, FormRules } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
document.title = "标识山西-找业务";
const disabledDate = (time) => {
  return time.getTime() < Date.now();
};
const router = useRouter();
const from1 = ref({
  keyWord: "",
  pageIndex: 1,
  pageSize: 8,
  total: 0,
});
const placeplace = ref("输入需求名称进行搜索");
let inputTitle = "";
let radio = ref(false);
router.currentRoute.value.query
  ? router.currentRoute.value.query.hasOwnProperty("inputTitle")
    ? (inputTitle = router.currentRoute.value.query.inputTitle)
    : ""
  : "";

from1.value.keyWord = inputTitle || "";
const list = ref([]);
const bottomList = ref([
  {
    title: "搜需求",
    checked: true,
  },
  {
    title: "搜人才",
    checked: false,
  },
]);
const composer = function (index) {
  // console.log(index.memberId);
  router.push({
    path: "/ShadowComposerHomepage",
    query: { id: index.memberId },
  });
};

const selectClick = function (index) {
  for (let i = 0; i < bottomList.value.length; i++) {
    if (bottomList.value[i] == index) {
      bottomList.value[i].checked = true;
      if (i == 0) {
        placeplace.value = "输入需求名称进行搜索";
      } else {
        placeplace.value = "输入人才名称进行搜索";
      }
    } else {
      bottomList.value[i].checked = false;
    }
  }
};
// 跳列表页
const goPagelink = function () {
  router.push({
    path: "/ShadowBusinessList",
  });
};
/* 跳转详情页 */
const goParticulars = function (item) {
  router.push({
    path: "/ShadowBusinessParticulars",
    query: {
      id: item.id,
    },
  });
};
const getList1 = function () {
  let obj = { ...from1.value };
  obj.condition = {};
  bottomList.value.forEach((e, index) => {
    if (e.checked) {
      obj.condition.type = index + 1;
    }
  });
  if (obj.condition.type == 2) {
    router.push({
      path: "/ShadowComposer",
      query: {
        inputTitle: from1.value.keyWord,
      },
    });
  } else {
    router.push({
      path: "/ShadowBusinessList",
      query: {
        inputTitle: from1.value.keyWord,
      },
    });
  }
};
let userList = ref();
let getuserList = function () {
  // 获取 创作者列表
  let params = {
    // realStatus: 2, // 实名认证 2 成功 固定传参
    // memberType: memberType.value != "" ? memberType.value : null, // 类型
    memberTypeld: "", // 条件查询
    pageSize: 8,
  };
  Axios("GET", "/member/front/index", params, false, function (res) {
    userList.value = res.data.rows;
  });
};
getuserList();
/* 发布需求 */
const checked = ref(false);
const showReleaseLease = function () {
  if (JSON.parse(localStorage.getItem("userList"))) {
    checked.value = true;
  } else {
    router.push({
      path: "/TgLogin",
    });
  }
};
const openWindow = function () {
  checked.value = false;
};
const getList = function () {
  let obj = { ...from1.value };
  obj.condition = {
    isHomePage: 1,
  };
  bottomList.value.forEach((e, index) => {
    if (e.checked) {
      obj.condition.type = index + 1;
    }
  });
  if (obj.condition.type == 2) {
    router.push({
      path: "/ShadowComposer",
      query: {
        inputTitle: from1.value.keyWord,
      },
    });
    return;
  }
  Axios("POST", "/material/material/need/list", obj, false, function (res) {
    if (res.data.code == 200) {
      // from1
      list.value = res.data.data.records;
    } else {
      ElMessage.error(res.data.message);
    }
  });
};
getList();
// 提交表单
const form = ref({
  contactInfo: "",
  deliveryTime: "",
  price: null,
  projectName: "",
  workName: "",
  projectDescription: "",
  skillType: "",
  workPlace: "",
});
type Form = {
  contactInfo: string;
  deliveryTime: string;
  price: number;
  projectName: string;
  projectDescription: string;
  skillType: string;
  workPlace: string;
};
type Rules = {
  [K in keyof Form]?: Array<FormItemRule>;
};
const formRef = ref<FormInstance>();
const checkPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('手机号不能为空'));
  } else {
    const reg = /^1[0-9]{10}$/
    if (reg.test(value)) {
      callback();
    } else {
      return callback(new Error('请输入正确的手机号'));
    }
  }
}
const rules = reactive<any>({
  contactInfo: [
    { required: true, message: "请输入联系方式", trigger: "blur" }, {
      validator: checkPhone, trigger: 'blur'
    },
  ],
  deliveryTime: [
    { required: true, message: "请选择交付日期", trigger: "change" },
  ],
  price: [{ required: true, message: "请输入价格", trigger: "change" }, {
    validator: (rule, value, cb) => {
      if (String(value).trim() == 'null') return;
      if (value.indexOf(".") != -1) {
        return cb(new Error('请输入正整数'));
      }
      return cb();
    }, trigger: 'blur'
  }],
  projectName: [
    { required: true, message: "请输入项目名称", trigger: "change" },
  ],
  projectDescription: [
    { required: true, message: "请输入项目描述", trigger: "change" },
  ],
});
const input = (e: any) => {
  // console.log(121);
  if (form.value.price / 1 < 1) return ElMessage.error("价格不能小于1");
};
const submitForm = () => {
  if (!radio.value) {
    return ElMessage.error("请同意合同协议");
  }
  // if (form.value.price / 1 < 1) return ElMessage.error("价格不能小于1");
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      let obj = { ...form.value };
      Axios("POST", "/material/material/need/sou", obj, false, function (res) {
        if (res.data.code == 200) {
          checked.value = false;
          radio.value = false;
          getList();
          formRef.value.clearValidate();
          formRef.value.resetFields();
        } else {
          ElMessage.error(res.data.message);
        }
      });
    } else {
      return false;
    }
  });
};
const handleClose = (e) => {
  formRef.value.clearValidate();
  formRef.value.resetFields();
  radio.value = false;
  checked.value = false;
  if (e) {
    getList();
  }
};
const openagreement = (val) => {
  window.open(`/agreement?name=${val}`, "_bank");
};
</script>

<style lang="less" scoped>
.body_top {
  margin: 0 auto;
  position: relative;
  background: rgba(0, 0, 0, 0.3);
}

.body_main {
  display: block;
  width: 12.8rem;
  margin: 0 auto;
}

.bg_img_div {
  width: 100%;
  position: relative;
  // z-index: -1;
  // background: rgba(0, 0, 0, 0.3);
  height: 7rem;
  // overflow: hidden;
  // position: relative;
  background: url("../../assets/newYXSCbg.png") no-repeat bottom center;
  background-size: auto 100%;
}

.bg_img_div>img {
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.body_top_abs {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.body_top_abs>.img_he {
  width: 100%;
  text-align: center;
  margin-top: 1.3rem;
}

.log_Img {
  text-align: center;
  width: 2.8rem;
}

.body_top_abs_gn {
  flex: 1;
  position: relative;
  width: 7.5rem;
  margin: 0 auto;
  margin-top: 0.9rem;
}

.ag_select {
  margin-bottom: 0.12rem;
}

.ag_select>span {
  margin-right: 0.4rem;
  color: #fff;
  font-size: 0.14rem;
  line-height: 0.16rem;
  padding-bottom: 0.03rem;
}

.ag_selectT {
  border-bottom: 0.02rem solid #fff;
}

.ag_selectY {
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0);
}

.ag_l {
  width: 100%;
  display: flex;
  justify-content: initial;
  align-items: center;
  margin-top: 0.12rem;
}

.ss_abs_c_srk {
  width: 8rem;
  display: flex;
  overflow: hidden;
  border-radius: 0.08rem;
}

.ss_abs_c_srk>input {
  flex-grow: 1;
  font-size: 0.14rem;
  border: 0rem solid #fff;
  padding: 0.16rem;
}

.ss_abs_c_srk>div {
  font-size: 0.14rem;
  color: #ffffff;
  background: #c01a26;
  padding: 0.16rem 0.24rem;
  display: flex;
  align-items: center;
}

.ss_abs_c_srk>div>img {
  width: 0.16rem;
  margin-right: 0.06rem;
}

.ss_abs_c_srk>div>input {
  border: 0rem solid #fff;
  background: #fff;
}

.body_top {
  width: 100%;
  position: relative;
}

.body_top_list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.bt1 {
  margin-top: 0.1rem;
  color: #ffffff;
  font-size: 0.3rem;
  text-align: center;
}

.bt2 {
  margin-top: 0.08rem;
  font-size: 0.16rem;
  color: #ffffff;
  text-align: center;
}

.log_box {
  position: absolute;
  bottom: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.45rem;
  width: 100%;

  img {
    // width: 1.2rem;
    height: 0.4rem;

    &:nth-of-type(2) {
      margin: 0 0.24rem;
    }
  }

  p {
    color: #fff;
    padding: 0 0.21rem;
  }
}

.body_main_a {
  padding: 0.3rem 0.9rem;
  box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(190, 198, 210, 0.25);
  border-radius: 0.12rem;
  background: #ffffff;
}

.body_main_a,
.body_main_a_left,
.body_main_a_left>div {
  display: flex;
  justify-content: space-between;
}

.body_main_a_left>div {
  align-items: center;
  margin-right: 0.2rem;
}

.body_main_a_left>div>img {
  width: 0.32rem;
  margin-right: 0.09rem;
}

.body_main_a_left>div>div {
  color: #333333;
  font-size: 0.16rem;
}

.body_main_a_right {
  padding: 0.04rem 0.12rem;
  border-radius: 1rem;
  background: linear-gradient(171deg, #fbe7ce 0%, #fed79e 100%);
  color: #785935;
  font-size: 0.14rem;
  display: flex;
  align-items: center;
}

.body_main_a_right>img {
  width: 0.3rem;
}

.ag_l {
  width: 100%;
  display: flex;
  justify-content: initial;
  align-items: center;
  margin-top: 0.12rem;
}

.ss_abs_c_srk {
  width: 8rem;
  display: flex;
  overflow: hidden;
  border-radius: 0.08rem;
}

.ss_abs_c_srk>input {
  flex-grow: 1;
  font-size: 0.14rem;
  border: 0rem solid #fff;
  padding: 0.16rem;
}

.ss_abs_c_srk>div {
  font-size: 0.14rem;
  color: #ffffff;
  background: #c01a26;
  padding: 0.16rem 0.24rem;
  display: flex;
  align-items: center;
}

.ss_abs_c_srk>div>img {
  width: 0.16rem;
  margin-right: 0.06rem;
}

.ss_abs_c_srk>div>input {
  border: 0rem solid #fff;
  background: #fff;
}

.ss_abs_c_center {
  padding: 0.16rem 0.24rem;
  font-size: 0.14rem;
  color: #fff;
}

.ss_abs_c_right {
  background: #c01a26;
  color: #fff;
  padding: 0.16rem 0.24rem;
  border-radius: 0.08rem;
  font-size: 0.14rem;
  flex: none;
}

.SL_hotSongwriter {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 0.7rem;
  margin-bottom: 0.3rem;
}

.SL_hotSongwriter_title {
  font-size: 0.24rem;
  color: #000;
}

.SL_hotSongwriter_click {
  font-size: 0.14rem;
  color: #333;
}

.dataBtn {
  width: 0.88rem;
  padding: 0.08rem 0.16rem;
  background: #c01a26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
  color: #fff;
}

.dataBtnQx {
  margin-right: 0.2rem;
  border: 1px solid #86909c;
  color: #333333;
  background: transparent;
}
</style>
